module.exports = __webpack_public_path__ + "img/serve-bg.32f3d174.jpg";